// extracted by mini-css-extract-plugin
module.exports = {"inner":"SectionSeo_inner__H_e2D","left":"SectionSeo_left__3FvZD"};